import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";
import SignInContainer from "src/containers/user/sign-in-container/sign-in-container";

function SignInPage() {
  const navigate = useNavigate();
  return (
    <div>
      <img
        onClick={() => navigate(appRoutesObj.getBasePath())}
        alt=""
        src="/assets/images/logo.svg"
        className="absolute left-6 top-5 z-20 h-7 mobile:h-7 mobile:left-4 mobile:top-9 cursor-pointer"
      />
      <SignInContainer/>
    </div>
  );
}

export default SignInPage;
